<div class="box-novo-compromisso" *ngIf="showModal" (click)="onBackgroundClick($event)">
  <div class="box-formulario" (click)="$event.stopPropagation()">
    <div class="row">
      <div class="col-md-6">
        <h5>Alterar Status do Agendamento</h5>
      </div>
      <div class="col-md-6 text-right" style="padding-top: 5px;">
        <i (click)="fecharModal()" class="fa fa-close"></i>
      </div>
      <hr class="hr-titulo">
      <form [formGroup]="formAlterar" id="formAlterar">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="status">Status</label>
              <input class="form-control" id="status" [value]="nomeStatusDestino" disabled>
              <span id="status-error-required" class="error mensagem-erro"
                    *ngIf="formAlterar.get('status')?.dirty &&
                        formAlterar.get('status')?.errors?.required"
              >O status não pode ser vazio <br></span>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label for="nota">Nota</label>
              <textarea id="nota" class="form-control" rows="5"
                        [ngClass]="{'is-invalid': formAlterar.get('nota')?.errors}"
                        formControlName="nota" placeholder="Digite uma nota sobre a alteração de status"></textarea>
              <span id="nota-error-required" class="error mensagem-erro"
                    *ngIf="formAlterar.get('nota')?.dirty &&
                        formAlterar.get('nota')?.errors?.required"
              >A nota não pode ser vazia <br></span>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="tarefasEncerrar" formControlName="tarefasEncerrar">
                <label class="form-check-label" for="tarefasEncerrar">
                  Encerrar tarefas relacionadas
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6" style="padding-top: 10px;margin-top: 20px;">
            <button class="btn btn-warning" (click)="fecharModal()">Cancelar</button>
          </div>
          <div class="col-md-6 pull-right text-right" style="padding-top: 10px;margin-top: 20px;">
            <button class="btn btn-primary" (click)="salvar()">Salvar</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
